interface ActionTypes {
  SEND_FEEDBACK_START: string;
  SEND_FEEDBACK_SUCCESS: string;
  SEND_FEEDBACK_FAILURE: string;
}

export const SendFeedbackActionTypes: ActionTypes = {
  SEND_FEEDBACK_START: '@@SEND_FEEDBACK_START',
  SEND_FEEDBACK_SUCCESS: '@@SEND_FEEDBACK_SUCCESS',
  SEND_FEEDBACK_FAILURE: '@@SEND_FEEDBACK_FAILURE'
};

export interface SendFeedbackState {
  feedback?: any;
  isSendingFeedback?: boolean;
  feedbackError?: any;
}
